const ENCRYPTION_TYPE = "AES-GCM";

let persistenceKey: CryptoKey = null;
let initializationVector: Uint8Array = null;

const setPersistenceKey = async () => {
	persistenceKey = await crypto.subtle.generateKey(
		{
			name: ENCRYPTION_TYPE,
			length: 256,
		},
		true,
		["encrypt", "decrypt"]
	);
	return persistenceKey;
};

const setInitializationVector = async () => {
	if (initializationVector) {
		throw new Error("Initialization vector already set");
	}
	initializationVector = self.crypto.getRandomValues(new Uint8Array(16));
	return initializationVector;
};

export const getPersistenceKey = async () => {
	return persistenceKey || (await setPersistenceKey());
};

export const getInitializationVector = async () => {
	return initializationVector || (await setInitializationVector());
};

export const transformRead = async (data: Uint8Array) => {
	if (typeof self === "undefined" || !self.crypto.subtle) {
		return data;
	}

	const decrypted = await self.crypto.subtle.decrypt(
		{
			name: ENCRYPTION_TYPE,
			iv: await getInitializationVector(),
		},
		await getPersistenceKey(),
		data
	);

	return decrypted;
};

export const transformWrite = async (data: ArrayBuffer) => {
	if (!(self || global).crypto.subtle) {
		return data;
	}

	const encrypted = await self.crypto.subtle.encrypt(
		{
			name: ENCRYPTION_TYPE,
			iv: await getInitializationVector(),
		},
		await getPersistenceKey(),
		data
	);
	return encrypted;
};
